export function formatDateRange(startDate, endDate) {
    const sourceStartDate = new Date(startDate);
    const sourceEndDate = new Date(endDate);
    
    const optionStartDate = { month: 'long', day: 'numeric' };
    const optionEndDate = { year: 'numeric', month: 'long', day: 'numeric' };
    
    const formattedStartDate = sourceStartDate.toLocaleDateString('en-US', optionStartDate);
    const formattedEndDate = sourceEndDate.toLocaleDateString('en-US', optionEndDate);
    
    return "From " + formattedStartDate + " To " + formattedEndDate;
  }
  
 
  export function formatDate(date) {
    if (date === null) {
      return 'Date not defined';
    }
    const sourceDate = new Date(date);
    const optionsDate = { year: 'numeric', month: 'long', day: 'numeric' };
    const formattedDate = sourceDate.toLocaleDateString('en-US', optionsDate);
   
    return  formattedDate
  }
  

